export default __webpack_public_path__ + "static/media/header-2.e4cbcf0f.jpg";